import { useMutation } from '@apollo/client/react';
import { useCallback, useEffect } from 'react';

import {
  BookPreparedAppointmentDocument,
  PreparedTelemedicineAppointmentFragment,
} from '~/graphql/generated/graphql';

export const useOpenOnlineWindow = () => {
  const openWindow = useCallback((encounterId: string) => {
    window.open(`/online/${encounterId}`, encounterId, 'resizable,scrollbars,status,noopener');
  }, []);
  const [bookAppointment, { loading, data }] = useMutation(BookPreparedAppointmentDocument);

  useEffect(() => {
    const encounterId = data?.bookAppointment?.encounter.id;
    if (encounterId) {
      openWindow(encounterId);
    }
  }, [data, openWindow]);

  const book = useCallback(
    async (appointmentId: string) => {
      await bookAppointment({
        variables: {
          input: {
            appointmentId,
          },
        },
      });
    },
    [bookAppointment],
  );
  const handleOpenOnlineWindow = useCallback(
    async (appointment: PreparedTelemedicineAppointmentFragment) => {
      if (appointment.status === 'pending') {
        await book(appointment.id);
      } else {
        if (appointment.encounter?.id) {
          openWindow(appointment.encounter.id);
        }
      }
    },
    [book, openWindow],
  );

  return { loading, handleOpenOnlineWindow };
};
